<template>
    <div class="addPodcastBack">
        <div class="addPodcast">
            <div class="addPodcast__top">
                <p class="addPodcast__top__title" v-if="type == 'podcast'">{{ isEdit ? 'Изменить подкаст' : 'Добавить подкаст' }}</p>
                <p class="addPodcast__top__title" v-if="type == 'option'">{{ isEdit ? 'Изменить опцию' : 'Добавить опцию' }}</p>
                <p class="addPodcast__top__title" v-if="type == 'rating'">{{ isEdit ? 'Изменить рейтинг' : 'Добавить рейтинг' }}</p>
                <p class="addPodcast__top__title" v-if="type == 'country'">{{ isEdit ? 'Изменить страну' : 'Добавить страну' }}</p>
                <p class="addPodcast__top__title" v-if="type == 'community'">{{ isEdit ? 'Изменить community' : 'Добавить community' }}</p>
                <p class="addPodcast__top__title" v-if="type == 'gide'">{{ isEdit ? 'Изменить гайд' : 'Добавить гайд' }}</p>
                <p class="addPodcast__top__title" v-if="type == 'question'">{{ isEdit ? 'Изменить вопрос' : 'Добавить вопрос' }}</p>
                <p class="addPodcast__top__sub">Укажите данные товара и добавьте покупку пользователю</p>
            </div>  
            <div class="line"></div>
            <div class="customInputWhite"  v-if="type == 'podcast'">
                <label>Название</label>
                <input placeholder="Название...."/>
            </div>
            <div class="customInputWhite"  v-if="type == 'podcast'">
                <label>Название категорий</label>
                <input placeholder="Название категорий...."/>
            </div>
            <div class="customInputFileWhite"  v-if="type == 'podcast'">
                <span>Изображение</span>
                <label class="customInput__file">
                    <div class="customInput__div">
                        <p>Загрузить изображение</p>
                        <img src="@/assets/icons/document.svg"/>
                    </div>
                    <input type="file" style="display: none;"/>
                </label>
            </div>
            <div class="customInputWhite"  v-if="type == 'podcast'">
                <label>Гиперссылка</label>
                <input placeholder="..."/>
            </div>
            <div class="customInputWhite"  v-if="type == 'option'">
                <label>Название</label>
                <input placeholder="Название...."/>
            </div>
            <div class="customInputWhite"  v-if="type == 'option'">
                <label>Название категорий</label>
                <input placeholder="Название категорий...."/>
            </div>
            <div class="customInputFileWhite"  v-if="type == 'option'">
                <span>Изображение</span>
                <label class="customInput__file">
                    <div class="customInput__div">
                        <p>Загрузить изображение</p>
                        <img src="@/assets/icons/document.svg"/>
                    </div>
                    <input type="file" style="display: none;"/>
                </label>
            </div>
            <div class="customInputWhite"  v-if="type == 'option'">
                <label>Гиперссылка</label>
                <input placeholder="..."/>
            </div>
            <div class="customInputWhite"  v-if="type == 'gide'">
                <label>Название подкаста</label>
                <input placeholder="Название рейтинга...."/>
            </div>
            <div class="customInputFileWhite"  v-if="type == 'gide'">
                <span>Изображение</span>
                <label class="customInput__file">
                    <div class="customInput__div">
                        <p>Загрузить изображение</p>
                        <img src="@/assets/icons/document.svg"/>
                    </div>
                    <input type="file" style="display: none;"/>
                </label>
            </div>
            <div class="customInputWhite"  v-if="type == 'gide'">
                <label>Гиперссылка</label>
                <input placeholder="..."/>
            </div>
            <div class="customInputWhite"  v-if="type == 'rating'">
                <label>Название подкаста</label>
                <input placeholder="Название рейтинга...."/>
            </div>
            <div class="customInputFileWhite"  v-if="type == 'rating'">
                <span>Изображение</span>
                <label class="customInput__file">
                    <div class="customInput__div">
                        <p>Загрузить изображение</p>
                        <img src="@/assets/icons/document.svg"/>
                    </div>
                    <input type="file" style="display: none;"/>
                </label>
            </div>
            <div class="customInputWhite"  v-if="type == 'rating'">
                <label>Гиперссылка</label>
                <input placeholder="..."/>
            </div>
            <div class="customInputWhite"  v-if="type == 'country'">
                <label>Community</label>
                <CustomSelect />
            </div>
            <div class="customInputFileWhite"  v-if="type == 'country'">
                <span>Изображение</span>
                <label class="customInput__file">
                    <div class="customInput__div">
                        <p>Загрузить изображение</p>
                        <img src="@/assets/icons/document.svg"/>
                    </div>
                    <input type="file" style="display: none;"/>
                </label>
            </div>
            <div class="customInputWhite" v-if="type == 'community'">
                <label>Название заголовка</label>
                <input type="Вопрос...."/>
            </div>
            <div class="customInputWhite" v-if="type == 'community'">
                <label>Ссылка</label>
                <input type="text" placeholder="..."/>
            </div>
            <div class="customInputWhite" v-if="type == 'question'">
                <label>Название вопроса</label>
                <input placeholder="Вопрос....">
            </div>
            <div class="customInputWhite" v-if="type == 'question'">
                <label>Ответ</label>
                <textarea placeholder="Ответ на вопрос ...."></textarea>
            </div>
            <div class="line"></div>
            <div class="addPodcast__buttons">
                <button class="addPodcast__buttons__save">{{ isEdit ? 'Изменить' : 'Добавить' }}</button>
                <button class="addPodcast__buttons__delete" @click="closeModal()">Закрыть</button>
            </div>
        </div>
    </div>
</template>
<script>
import CustomSelect from '../customSelect.vue';
export default {
    components: {
        CustomSelect
    },
    props: [
      'type',
      'isEdit'
    ],
    methods: {
        closeModal(){
            this.$emit('closeModal')
        }
    }
}
</script>
<style lang="scss" scoped>
.line{
    border: 1px solid #0000001A;
    width: 100%;
}
    .addPodcastBack{
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        z-index: 999;
        align-items: center;
        background-color: #0000007a;
    }
    .addPodcast{
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        width: 33%;
        background-color: white;
        padding: min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px) 60px;
        border-radius: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        &__top{
            display: flex;
            flex-direction: column;
            gap: 10px;
            text-align: center;
            &__title{
                font-size: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.2153))), 32px);
                color: #2BC38E;
                font-weight: 600;
            }
            &__sub{
                color: #0000008A;
            }
        }
        &__select{
            width: 100%;
        }
        &__block{
            display: flex;
            flex-wrap: wrap;
            gap: 4%;
            width: 100%;
            row-gap: 10px;
            P{
                color: #0000008A;   
            }
        }
    &__buttons{
        display: flex;
        width: 100%;
        gap: 4%;
        button{
            width: 48%;
            border: none;
            height: min(max(25px, calc(1.5625rem + ((1vw - 7.68px) * 2.1701))), 50px);
            border-radius: 10px;
        }
        &__save{
            color: white;
            font-size: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            background-color: #2BC38E;
            border: 1px solid #2BC38E;
            transition: all 0.5s ease;
            &:hover{
                color: white;
                background-color: #28906c9f;
            }
        }
        &__delete{
            background-color: inherit;
            border: 1px solid #0000001A !important;
            color: #0000008A;
            font-size: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            transition: all 0.5s ease;
            &:hover{
                color: white;
                background-color: #2BC38E;
                border: 1px solid #2BC38E;
            }
        }
    }
    }
</style>